// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Pl-z","tupacHeader":"Ql-z","tupacHeader2":"Rl-z","tupacMenu":"Sl-z","tupacMenu2":"Tl-z","tupacMain":"Ul-z","tupacMain2":"Vl-z"};